/* eslint-disable no-restricted-imports -- legacy_modulesを削除できるまで無効化 */
import React, { Suspense } from 'react'

import { ChakraProvider } from '@chakra-ui/react'
import AgoraRTC, { AgoraRTCProvider } from 'agora-rtc-react'
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import { TouchBackend } from 'react-dnd-touch-backend'
import { isTouchDevice } from 'src/utils/is-touch-device'

import { ErrorBoundary } from './components/ErrorBoundary/ErrorBoundary'
import { LoadingDots } from './components/LoadingDots/LoadingDots'
import { ModalProvider } from './hooks/use-modal'
import { OrientationAlertProvider } from './hooks/use-orientation-alert'
import { useReloadWindow } from './hooks/use-reload-window'
import { SpinnerProvider } from './hooks/use-spinner'
import { Router } from './legacy_modules/router'
import { theme as chakraUITheme } from './lib/chakra-theme'
import { MonitoringProvider } from './lib/monitoring/monitoring'

const agoraClient = AgoraRTC.createClient({
  mode: 'rtc',
  codec: 'vp8',
})

const App: React.FC = () => {
  const dndProviderBackend = isTouchDevice() ? TouchBackend : HTML5Backend

  useReloadWindow()

  return (
    <DndProvider backend={dndProviderBackend}>
      <ChakraProvider theme={chakraUITheme}>
        <ErrorBoundary>
          <Suspense fallback={<LoadingDots />}>
            <OrientationAlertProvider>
              <MonitoringProvider>
                <ModalProvider>
                  <AgoraRTCProvider client={agoraClient}>
                    <SpinnerProvider>
                      <Router />
                    </SpinnerProvider>
                  </AgoraRTCProvider>
                </ModalProvider>
              </MonitoringProvider>
            </OrientationAlertProvider>
          </Suspense>
        </ErrorBoundary>
      </ChakraProvider>
    </DndProvider>
  )
}

export default App
